import { Button } from "primereact/button";

const Footer = () => {
  return (
    <div
      className="bg-tru-dark text-white text-center py-3 shadow-4"
      style={{
        marginTop: "100px",
        backgroundImage: "url('/footerbg.png')",
        backgroundRepeat: "repeat",
      }}
    >
      <p>
        Тракийски университет &copy; {new Date().getFullYear()}, версия {import.meta.env.VITE_BUILD_DATE}
      </p>
      <a href="https://trakia-uni.bg/" target="_blank" rel="noreferrer">
        <Button icon="pi pi-globe" label="Главен сайт" className="p-button-rounded p-button-text p-button-plain" />
      </a>
      <a href="https://priem.uni-sz.bg/" target="_blank" rel="noreferrer">
        <Button
          icon="pi pi-user-plus"
          label="Прием Бакалаври"
          className="p-button-rounded p-button-text p-button-plain"
        />
      </a>
      <a href="https://magistri.uni-sz.bg/" target="_blank" rel="noreferrer">
        <Button
          icon="pi pi-user-plus"
          label="Прием Магистри"
          className="p-button-rounded p-button-text p-button-plain"
        />
      </a>
      <a href="https://ftt.uni-sz.bg/international-students/login" target="_blank" rel="noreferrer">
        <Button
          icon="pi pi-user-plus"
          label="International Students"
          className="p-button-rounded p-button-text p-button-plain"
        />
      </a>
    </div>
  );
};

export default Footer;
